import React from 'react'
import { ButtonProps } from '../Button/Button'
import { TheBigPOSApi } from '../../lib/TheBigPOSClient'
import { downloadBlob } from '../../services/utils'
import SplitButton from '../Button/SplitButton'

export type DownloadSSOMetadataButtonProps = {
	ssoIntegration: 'ConsumerConnect' | 'TheBigPOS'
	regenerateText?: string
} & Omit<ButtonProps, 'onClick'>

const DownloadSSOMetadataButton = ({
	ssoIntegration,
	regenerateText = 'Regenerate Metadata',
	...rest
}: DownloadSSOMetadataButtonProps) => {
	const handleClick = async () => {
		const response = await TheBigPOSApi.getSamlMetadata(
			ssoIntegration, // Bug in the SDK requires 2 params instead of 1. The first param is not used
			ssoIntegration.toLowerCase(),
			{ format: 'blob' }
		)

		const filename = `${ssoIntegration.toLowerCase()}_metadata.xml`
		downloadBlob(response.data, filename)
	}

	const regenerateMetadata = async () => {
		await TheBigPOSApi.createOrReplaceSamlMetadata(
			ssoIntegration,
			ssoIntegration.toLowerCase()
		)

		handleClick()
	}

	return (
		<SplitButton
			label={rest.text}
			onClick={handleClick}
			{...rest}
			menuItems={[
				{
					label: regenerateText,
					onClick: regenerateMetadata,
				},
			]}
		/>
	)
}

export default DownloadSSOMetadataButton
